import { memo } from 'react';
import type { FC } from 'react';
import { CameraCardFooter } from './CameraCardFooter';
import type { CameraState, SessionState } from '@smolt/shared/types';

export interface CameraCardFooterWrapperProps {
  cameraState: CameraState;
  sessionState: SessionState;
  onSettingsClick: () => void;
  onActionClick: () => void;
  isMobile?: boolean;
}

/**
 * CameraCardFooterWrapper - Memoized wrapper for Footer
 *
 * Purpose: Prevent Footer re-render when CameraCardContent updates
 * - Content re-renders every 100ms during counting (statusText, weight, duration changes)
 * - This wrapper ensures Footer only re-renders when cameraState or sessionState changes
 * - Prevents DOM reflow during button clicks, ensuring stable click targets
 */
export const CameraCardFooterWrapper: FC<CameraCardFooterWrapperProps> = memo(
  ({ cameraState, sessionState, onSettingsClick, onActionClick, isMobile = false }) => {
    return (
      <div style={{ paddingTop: 'clamp(4px, 2.63cqh, 10px)', flexShrink: 0 }}>
        <CameraCardFooter
          cameraState={cameraState}
          sessionState={sessionState}
          onSettingsClick={onSettingsClick}
          onActionClick={onActionClick}
          isMobile={isMobile}
        />
      </div>
    );
  }
);

CameraCardFooterWrapper.displayName = 'CameraCardFooterWrapper';
